import React, { useState, useEffect } from 'react';
import chatCache from '../utils/cache';

const CacheManager = () => {
  const [stats, setStats] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    updateStats();
  }, []);

  const updateStats = () => {
    const cacheStats = chatCache.getStats();
    setStats(cacheStats);
  };

  const clearCache = () => {
    chatCache.clear();
    updateStats();
    console.log('Cache cleared');
  };

  const formatBytes = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  if (!isVisible) {
    return (
      <button
        onClick={() => setIsVisible(true)}
        className="fixed bottom-4 right-4 bg-gray-800 text-white p-2 rounded-full text-xs z-50"
        title="Cache Manager"
      >
        💾
      </button>
    );
  }

  return (
    <div className="fixed bottom-4 right-4 bg-white border border-gray-300 rounded-lg shadow-lg p-4 max-w-sm z-50">
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-sm font-semibold">Cache Manager</h3>
        <button
          onClick={() => setIsVisible(false)}
          className="text-gray-500 hover:text-gray-700"
        >
          ✕
        </button>
      </div>
      
      {stats && (
        <div className="space-y-2 text-xs">
          <div className="flex justify-between">
            <span>Total Items:</span>
            <span className="font-medium">{stats.totalItems}</span>
          </div>
          <div className="flex justify-between">
            <span>Total Size:</span>
            <span className="font-medium">{formatBytes(stats.totalSize)}</span>
          </div>
          <div className="flex justify-between">
            <span>Max Items:</span>
            <span className="font-medium">{stats.maxSize}</span>
          </div>
          
          <div className="border-t pt-2 mt-2">
            <div className="font-medium mb-1">By Type:</div>
            {Object.entries(stats.byType).map(([type, count]) => (
              <div key={type} className="flex justify-between text-xs">
                <span className="capitalize">{type}:</span>
                <span>{count}</span>
              </div>
            ))}
          </div>
        </div>
      )}
      
      <div className="mt-3 pt-3 border-t">
        <button
          onClick={clearCache}
          className="w-full bg-red-500 text-white py-1 px-2 rounded text-xs hover:bg-red-600"
        >
          Clear Cache
        </button>
        <button
          onClick={updateStats}
          className="w-full bg-blue-500 text-white py-1 px-2 rounded text-xs hover:bg-blue-600 mt-1"
        >
          Refresh Stats
        </button>
      </div>
    </div>
  );
};

export default CacheManager; 